// src/api/dateAgendaApi.js
import axios from 'axios';
import endpoints from '../endpoints'

export const fetchDateAgenda = async () => {
    const response = await axios.get(endpoints.dateAgendaList);

    const datas = response.data.list;

    // 返回分頁資訊和內容
    return {
        day1: datas.filter((item) => item.eventDay === "1")[0],
        day2: datas.filter((item) => item.eventDay === "2")[0],
    };
};
